import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ModalContainerComponent } from '../../../shared/components/modal-container/modal-container.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { IBreadcrumbs } from '../../../shared/components/breadcrumbs/breadcrumbs.component';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonContent, } from "@ionic/angular/standalone";
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { monitoringMobilePage } from "../mobile/monitoring/monitoring.mobile.component";

@Component({
    selector: 'app-settings',
    templateUrl: './mentorage.page.html',
    styleUrls: ['./mentorage.page.scss'],
    imports: [
        IonContent,
        CommonModule,
        ModalContainerComponent,
        MatGridListModule,
        MatFormFieldModule,
        TranslateModule,
        MatSelectModule,
        ReactiveFormsModule,
        FormsModule,
        MatIconModule,
        RouterModule,
        monitoringMobilePage
    ]
})
export class MentoragePage implements OnInit {

  public breadcrumbsList: IBreadcrumbs[] = [{
    icon: 'mentorage',
    routerLink: '',
    isSvgIcon: true,
    label: 'MENTORAGE'
  }]

  public tableRowSpan: number = 14

  constructor (
  ) { }


  ngOnInit() {
  }

  ngOnDestroy() {
  }

}
